module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyTextFirstPara"
  }, [_vm._v("The Wild Blue U saga was written over a period of 15 years and I received much help from reviewers, contributors of anecdotes, historians, former cadets and faculty members, editors, agents, friends, and a host of other helpers. As such, I cannot possibly thank everyone who has contributed to the saga as I’m sure I will leave someone out; but nevertheless, here goes: Kevin J. Anderson, Rebecca Moesta, Don Erbschloe, Vickie Erbschloe, John Silbersack, Matt Bialer, Lori Peterkin and her Book Club, Lisa Ice, Ken Zeringue, Vivian Trask, Don Shepherd, Elizabeth Muenger, Joe Gross, Craig Hendrickson, Mike Heil, Bill Sabol, Jeff Dotur, Harald Dogliani, Gary Ganong, Jim Parsons, Bob DeBerry, Hugh Gordon, Deane Burbank, Dick Halloran, Phil Gronseth, Curt McIntyre, Jim Mateos, Chris Jaremko, Yvonne Kinkaid, John Paul Fraser Fisher, Ken Henderson, Nelson O’Rear, Steve Whitehouse, Don Cole, Bob Duffner, and of course, Cindy Beason.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d94568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0005.vue
// module id = 72
// module chunks = 0